export default {
  schedule: {
    type: Object,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/reverser/resources/props.js